import { render, staticRenderFns } from "./Tema2_2-2.vue?vue&type=template&id=642a4eca&"
import script from "./Tema2_2-2.vue?vue&type=script&lang=js&"
export * from "./Tema2_2-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports